var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFscUpdateClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.187,
    height: 25.187,
    viewBox: "0 0 25.187 25.187",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cancel",
    transform: "translate(0 -0.005)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11987",
    "data-name": "Group 11987",
    transform: "translate(0 0.005)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37957",
    "data-name": "Path 37957",
    d: "M21.5,3.689a12.593,12.593,0,1,0,0,17.819A12.614,12.614,0,0,0,21.5,3.689ZM17.79,16.311A1.05,1.05,0,1,1,16.306,17.8l-3.712-3.713L8.883,17.794A1.05,1.05,0,1,1,7.4,16.31L11.109,12.6,7.4,8.887A1.05,1.05,0,0,1,8.882,7.4l3.712,3.712L16.305,7.4A1.05,1.05,0,1,1,17.79,8.887L14.078,12.6Z",
    transform: "translate(0 -0.005)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFscUpdateClose);
export default __webpack_public_path__ + "static/media/fsc-update-close.e8978198.svg";
export { ForwardRef as ReactComponent };